import LocalStorage from './LocalStorage';
import SessionStorage from './SessionStorage';
import CookieStorage from './CookieStorage';

const COOKIE_DAYS = 3650;

function isUsableValue(v) {
  if (v === undefined || v === null) return false;
  if (v === '' || v === 'undefined' || v === 'null') return false;
  return true;
}

// LG WebOS hat kein keymanager-Pendant. Defense-in-Depth ueber localStorage,
// (persistenten) Cookie und sessionStorage. localStorage ueberlebt App-Updates
// auf WebOS i.d.R. automatisch; die Spiegel decken Cache-Resets / Pro:Centric
// Reinitialisierungen ab.
export default class LGKeyStorage {
  static get(name) {
    const sources = [
      ['localStorage',   () => LocalStorage.get(name)],
      ['cookie',         () => CookieStorage.get(name)],
      ['sessionStorage', () => SessionStorage.get(name)],
    ];
    for (const [source, getter] of sources) {
      let v;
      try { v = getter(); } catch (e) { continue; }
      if (isUsableValue(v)) {
        if (source !== 'localStorage') {
          console.log(`[LGKeyStorage] re-hydrating "${name}" from ${source}`);
          this._mirror(name, v);
        }
        return v;
      }
    }
    return undefined;
  }

  static save(name, value) {
    this._mirror(name, value);
    return Promise.resolve();
  }

  static remove(name) {
    try { LocalStorage.remove(name); } catch (e) {}
    try { SessionStorage.remove(name); } catch (e) {}
    try { CookieStorage.remove(name); } catch (e) {}
  }

  static _mirror(name, value) {
    try { LocalStorage.save(name, value); } catch (e) {}
    try { SessionStorage.save(name, value); } catch (e) {}
    try { CookieStorage.save(name, value, COOKIE_DAYS); } catch (e) {}
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/LG.js